// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2351) return "css/2351-4cac56f1.css";
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"3095":"688b4616","3808":"688b4616","9667":"688b4616"}[chunkId] + ".css";
};